/* @flow */
import React from 'react';
import Moment from 'react-moment';
import { graphql, createFragmentContainer } from 'react-relay';
import type { TimeSlot_timeSlot } from './__generated__/TimeSlot_timeSlot.graphql';

type Props = {
  timeSlot: TimeSlot_timeSlot,
};

const TimeSlot = ({ timeSlot: { startDate, duration } }: Props) => (
  <span>
    <Moment fromNow date={startDate} format="D MMM YYYY" />
    <span>{` - ${duration.hours} Hour(s) ${duration.minutes} Minutes`}</span>
  </span>
);

export default createFragmentContainer(TimeSlot, {
  timeSlot: graphql`
    fragment TimeSlot_timeSlot on TimeSlot {
      id
      startDate
      duration {
        hours
        minutes
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/job/components/TimeSlot.js